import { render } from "./Error-logs-page.vue?vue&type=template&id=2a352f32&scoped=true"
import script from "./Error-logs-page.vue?vue&type=script&lang=js"
export * from "./Error-logs-page.vue?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&id=2a352f32&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a352f32"]])

export default __exports__